<template>
  <path
    d="M7 13.0002C8.66 13.0002 10 11.6602 10 10.0002C10 8.34018 8.66 7.00018 7 7.00018C5.34 7.00018 4 8.34018 4 10.0002C4 11.6602 5.34 13.0002 7 13.0002ZM19 7.00018H13C11.9 7.00018 11 7.90018 11 9.00018V14.0002H3V6.00018C3 5.45018 2.55 5.00018 2 5.00018C1.45 5.00018 1 5.45018 1 6.00018V19.0002C1 19.5502 1.45 20.0002 2 20.0002C2.55 20.0002 3 19.5502 3 19.0002V17.0002H21V19.0002C21 19.5502 21.45 20.0002 22 20.0002C22.55 20.0002 23 19.5502 23 19.0002V11.0002C23 8.79018 21.21 7.00018 19 7.00018Z"
  />
</template>
